<template>
  <PageBreadcrumb
    :crumbs="[{
      link: '/aste/',
      label: 'Gestione Aste'
    }, {
      label: 'Gestione Allegati ' + auction.name
    }]"
  />

  <div class="flex justify-between mb-4">
    <div class="flex-grow">
      <SearchInput v-model="search" />
    </div>
    <div class="self-end">
      <ActionButton
        v-if="auction.auctionStatus == 'DRAFT' && authStore.canManageAuctionOrCebis"
        @click="router.push('/aste/' + auctionId + '/allegati/crea')"
      >
        <PlusCircleIcon class="w-5 h-5 inline-block" />
        Carica nuovo Allegato
      </ActionButton>
    </div>
  </div>

  <DataTable :data="data">
    <template #heading>
      <tr>
        <SortableColumn
          v-model="sortStatus"
          name="description"
        >
          Descrizione
        </SortableColumn>

        <th class="text-right p-2" />
      </tr>
    </template>
    <template #body>
      <tr
        v-for="attachment in data"
        :key="'attachment-table-tr-' + attachment.uuid"
        class="odd:bg-gray-100"
      >
        <td class="p-2">
          {{ attachment.description }}
        </td>

        <td class="p-2 text-right">
          <a
            :href="config.AOL_API_URL + '/auction-attachment/' + attachment.uuid + '?auth=' + accessToken"
            target="_blank"
            title="Scarica Allegato"
          >
            <ArrowDownTrayIcon class="h-5 w-5 inline-block mx-1 " />
          </a>
          <a
            v-if="authStore.canManageAuctionOrCebis"
            href="#"
            title="Elimina Allegato"
            @click.prevent="destroy(attachment)"
          >
            <TrashIcon class="h-5 w-5 inline-block mx-1 " />
          </a>
        </td>
      </tr>
    </template>
  </DataTable>

  <DataTablePaginator
    :count="count"
    :count-all="countAll"
    :count-filtered="countFiltered"
    :current-page="currentPage"
    :has-next="hasNext"
    :has-prev="hasPrev"
    :next="next"
    :prev="prev"
    :total-pages="totalPages"
  />
</template>

<script setup>
import { useAuth0 } from "@auth0/auth0-vue";
import {
  ArrowDownTrayIcon,
  PlusCircleIcon,
  TrashIcon} from "@heroicons/vue/24/outline";
import { inject,ref } from "vue";
import { useRoute, useRouter } from 'vue-router';

import ActionButton from "@/components/ActionButton.vue";
import DataTable from "@/components/list/DataTable.vue";
import DataTablePaginator from "@/components/list/DataTablePaginator.vue";
import SearchInput from "@/components/list/SearchInput.vue";
import SortableColumn from "@/components/list/SortableColumn.vue";
import PageBreadcrumb from "@/components/PageBreadcrumb.vue";
import useAxios from '@/composables/axios.js'
import useDataTable from '@/composables/datatable.js'
import { useAuthStore } from '@/stores/auth'

const search = ref('')

const sortStatus = ref(["position", -1]);

const router = useRouter()
const route = useRoute()
const axios = useAxios()
const authStore = useAuthStore()
const { getAccessTokenSilently } = useAuth0();

const config = inject('config')
const accessToken = await getAccessTokenSilently()

const auctionId = route.params.auctionId
const auctionResp = await axios.get('/auction/' + auctionId);
const auction = ref(auctionResp.data);

const { data, count, countFiltered, countAll, currentPage, totalPages, next, prev, hasPrev, hasNext, doFilter, action } = await useDataTable({
  endpoint: "/auction-attachment/list/" + auctionId,
  sortStatus,
  search,
  searchProperties: ['description']
})

const destroy = (attachment) => {
  action('delete', 'auction-attachment/' + attachment.uuid, 'Allegato eliminato con successo')
}

</script>
